<template>
  <div>
    <TextInputConfiguration
      :controller="WindowStringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
  </div>
</template>

<script>
import {inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'

export default {
  name: 'OffsetX',
  components:{
    TextInputConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      elementsConfig:[],
      WindowStringCtrller:new inputTextConfCtrller(ConfigName.OffsetXPreProc,'Offset','Please give a numerical value','0',(value)=>{return !isNaN(value)}),
    }
  },
  mounted(){
    this.elementsConfig = [
     this.WindowStringCtrller
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
}
</script>

<style>

</style>